import gql from 'graphql-tag';

const CATEGORYGQL = `{
  uid
  title
  heading
  statement
  icon {
    url
  }
  displayOrder
  articles {
    uid
  }
  quickLink
  category {
    uid
    title
  }
  TitleOfTheBrowser
  MetaTagSection {
    name
    content
  }
  externalUrl
  elements {
    ... on ComponentElementsGlobalComponent {
      __typename
      title
      type
      copy
      contentSectionID
        genericComponent {
          uid
          title
          copy
        }
    }
  }
  sub_categories(sort: $sort) {
    uid
    title
    displayOrder
    description
    externalUrl
    statement
    icon {
      url
    }
    articles {
      uid
    }
    sub_categories {
      uid
    }
    MobileAppsWebViewDeepLink{
      cableCustomerExternalUrl
      mobileCustomerExternalUrl
    }
  }
}
`;

export const CATEGORY_QUICK_LINKS_QUERY = gql`
  query CategoryQuery($sort: String!) {
    categories(where: { quickLink: true }, sort: $sort)
    ${CATEGORYGQL}
  }
`;

export const CATEGORY_QUERY = gql`
  query CategoryQuery($uid: String!) {
    categories(where: { uid: $uid }) {
      id
      title
      statement
    }
  }
`;

export const CATEGORIES_TREELEVEL_QUERY = gql`
  query CategoryQuery {
    categories {
      uid
      title
      parent: category {
        uid
        title
      }
    }
  }
`;

export const CATEGORIES_AND_SUBCATEGORIES_QUERY = gql`
  query CategoryQuery($uid: String!, $sort: String!) {
    categories(where: { uid: $uid }, sort: $sort)
    ${CATEGORYGQL}
  }
`;

export const CATEGORY_CHANGE_PACKAGE = gql`
  query CategoryQuery($uid: String) {
    categories(where: { uid: $uid }) {
      title
      heading
      parent: category {
        uid
        title
      }
      MetaTagSection {
        name
        content
      }
      elements {
        ... on ComponentElementsGlobalComponent {
          genericComponent {
            ... on ComponentElementsGenericComponent {
              icon {
                url
              }
              ctas {
                label
              }
              listOfContent {
                text
              }
            }
          }
        }
      }
    }
  }
`;
